import { NavLink } from 'react-router-dom'
import {Link} from "react-router-dom"
import { FaHome, FaUserAlt, FaArchive, FaHeadSideMask, FaMapMarkerAlt, FaMountain, FaClock, FaCalendarCheck, FaRegCalendarAlt, FaBookOpen, FaBook, FaBookmark, FaBookReader, FaBell, FaCheckCircle, FaPencilAlt } from "react-icons/fa"
import { AiOutlineLeft } from "react-icons/ai"
import { HiOutlineDocumentReport } from "react-icons/hi"
import { MdLogout, MdOutlineInventory, MdPendingActions, MdOutlineMuseum } from "react-icons/md"
import {useAuth} from "./../contextos/AuthContext"
import Logo from '../imagenes/logosidebargreen.png'
import styled from "styled-components"
import { useState } from 'react'

const Container = styled.div`
    position: sticky;
    padding-top: ${({isOpen}) => (isOpen ?
        `1rem` : `3.5rem`)};
    padding-left: 1rem;
    padding-right: 1rem;
    background: #f2f4f4;
    border-right: 1px solid rgba(0, 0, 0, .1);
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.2);
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: rgba(0,114,56,.8) #f2f2f2;
    ::-webkit-scrollbar{
        width: 5px;
    }
    ::-webkit-scrollbar-thumb{
        background: rgba(0,114,56,.8);
    }
    .sidebarButton{
        position: absolute;
        top: ${({isOpen}) => (isOpen ?
            `1rem` : `1.1rem`)};
        right: ${({isOpen}) => (isOpen ?
            `12rem` : `1.8rem`)};
        width: 2.28rem;
        height: 2.28rem;
        border: none;
        border-radius: 50%;
        background: #f2f4f4;
        box-shadow: 2px 0 5px rgba(0, 0, 0, .5);
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: all 0.3s;
        transform: ${({isOpen}) => (isOpen ?
            `initial` : `rotate(180deg)`)};
        letter-spacing: inherit;
        color: inherit;
        font-size: inherit;
        padding: 0;
        font-family: inherit;
        outline: none;
        svg{
            color: rgba(0, 0, 0, .7);
        }
    }
    .LogoContent{
        display: ${({isOpen}) => (isOpen ?
            `flex` : `none`)};
        justify-content: center;
        align-items: center;
        margin-bottom: 1rem;
        
        .imgContent{
            display: flex;
            justify-content: center;
            img{
                width: 35%;
            }
            cursor: pointer;
            transition: all 0.3s;
            /*transform: ${({isOpen}) => (isOpen ?
                `scale(1)` : `scale(1.8)`)};*/
        }
    }
    .LinkContainer{
        display: flex;
        overflow: hidden;
        :hover{
            .LinkIcon{
                transition: all .5s;
                padding-left: 2rem;
            }
        }
    }
    .Links{
        display: flex;
        align-items: center;
        justify-content: ${({isOpen}) => (isOpen ?
            `left` : `center`)};
        text-decoration: none;
        padding: calc(0.57rem - 2px) 0;
        color: rgba(0, 0, 0, .7);
        width: 100%;
        .LinkIcon{
            padding: 0.57rem 1.14rem;
            display: flex;
            svg{
                font-size: 1.3rem;
                transform: ${({isOpen}) => (isOpen ?
                    `scale(1)` : `scale(1.2)`)};
            }
        }
        &.active{
            .BotonDropdown{
                background: #000;
            }
            color: #007238;
            background: rgba(0,114,56,.3);
            .LinkIcon{
                svg{
                    color: #007238;
                }
            }
        }
        :hover{
            background: rgba(0,114,56,.3);
        }
    }
    .ContainerInventario{
        background: #fafbfb;
        display: block;
        height: 0;
        overflow: hidden;
        transition: all .5s;
        &.active{
            border: 1px solid rgba(0, 0, 0, 0.2);
            height: 13.3rem;
        }
    }
    .ContainerSolicitudVisitas{
        background: #fafbfb;
        display: block;
        height: 0;
        overflow: hidden;
        transition: all .5s;
        &.active{
            border: 1px solid rgba(0, 0, 0, 0.2);
            height: 10.6rem;
        }
    }
    .ContainerVisitasDirectas{
        background: #fafbfb;
        display: block;
        height: 0;
        overflow: hidden;
        transition: all .5s;
        &.active{
            border: 1px solid rgba(0, 0, 0, 0.2);
            height: 3.4rem;
        }
    }
    .ContainerPublicaciones{
        background: #fafbfb;
        display: block;
        height: 0;
        overflow: hidden;
        transition: all .5s;
        &.active{
            border: 1px solid rgba(0, 0, 0, 0.2);
            height: 11.2rem;
        }
    }
    .BotonDropdown{
        cursor: pointer;
        border-radius: .5rem;
        display: flex;
        align-items: center;
        padding: calc(0.57rem - 2px) 0;
        justify-content: ${({isOpen}) => (isOpen ?
            `left` : `center`)};
        .LinkIcon{
            padding: 0.57rem 1.14rem;
            display: flex;
            svg{
                font-size: 1.3rem;
                color: rgba(0, 0, 0, .7);
                transform: ${({isOpen}) => (isOpen ?
                    `scale(1)` : `scale(1.2)`)};
            }
        }
        &.Inventario{
            transition: all .5s;
            &.active{
                .LinkIcon{
                    svg{
                        color: #007238;
                    }
                }
                background: #fafbfb;
                border-radius: .5rem .5rem 0 0;
                border-top: 1px solid rgba(0, 0, 0, 0.2);
                border-left: 1px solid rgba(0, 0, 0, 0.2);
                border-right: 1px solid rgba(0, 0, 0, 0.2);
            }
            :hover{
                svg{
                    animation-name: movimientoSVG;
                    animation-duration: 1s;
                }
            }
        }
        &.SolicitudVisitas{
            transition: all .5s;
            &.active{
                .LinkIcon{
                    svg{
                       color: #007238;
                    }
                }
                background: #fafbfb;
                border-radius: .5rem .5rem 0 0;
                border-top: 1px solid rgba(0, 0, 0, 0.2);
                border-left: 1px solid rgba(0, 0, 0, 0.2);
                border-right: 1px solid rgba(0, 0, 0, 0.2);
            }
            :hover{
                svg{
                    animation-name: movimientoSVG;
                    animation-duration: 1s;
                }
            }
        }
        &.VisitasDirectas{
            transition: all .5s;
            &.active{
                .LinkIcon{
                    svg{
                       color: #007238;
                    }
                }
                background: #fafbfb;
                border-radius: .5rem .5rem 0 0;
                border-top: 1px solid rgba(0, 0, 0, 0.2);
                border-left: 1px solid rgba(0, 0, 0, 0.2);
                border-right: 1px solid rgba(0, 0, 0, 0.2);
            }
            :hover{
                svg{
                    animation-name: movimientoSVG;
                    animation-duration: 1s;
                }
            }
        }
        &.Publicaciones{
            transition: all .5s;
            &.active{
                .LinkIcon{
                    svg{
                       color: #007238;
                    }
                }
                background: #fafbfb;
                border-radius: .5rem .5rem 0 0;
                border-top: 1px solid rgba(0, 0, 0, 0.2);
                border-left: 1px solid rgba(0, 0, 0, 0.2);
                border-right: 1px solid rgba(0, 0, 0, 0.2);
            }
            :hover{
                svg{
                    animation-name: movimientoSVG;
                    animation-duration: 1s;
                }
            }
        }
    }
    .SidebarTema{
        color: rgba(0, 0, 0, .7);
        margin: 0;
        font-size: ${({isOpen}) => (isOpen ?
            `1rem` : `.72rem`)};
        text-align: ${({isOpen}) => (isOpen ?
            `left` : `center`)};
        &.Principal{
            color: rgba(0, 0, 0, .3);
            margin-top: 1rem;
            margin-bottom: .5rem;
        }
    }
    @keyframes movimientoSVG{
        0%{transform: translateX(-75px);}
        100%{transform: translateX(0px);}
    }
`;

const Divider = styled.div`
    height: 1px;
    width: 100%;
    background: #fff;
    margin: 1rem 0;
`;

const Sidebar = ({sidebarOpen, setSidebarOpen}) => {
    const {idTipoUsuario, sesionOff, nombresUsuario} = useAuth();
    const [mostrarMenuInventario, setMostrarMenuInventario] = useState(false);
    const [mostrarMenuSolicitudVisitas, setMostrarMenuSolicitudVisitas] = useState(false);
    const [mostrarMenuVisitasDirectas, setMostrarMenuVisitasDirectas] = useState(false);
    const [mostrarMenuPublicaciones, setMostrarMenuPublicaciones] = useState(false);

    const menuPrincipal = [
        {
            label: "Inicio",
            icon: <FaHome />,
            to: "/"
        }
    ]
    const inventarioArray = [
        {
            label: "Objetos",
            icon: <FaHeadSideMask />,
            to: "/objetos"
        },
        {
            label: "Materiales",
            icon: <FaArchive />,
            to: "/material"
        },
        {
            label: "Culturas",
            icon: <FaMountain />,
            to: "/culturas"
        },
        {
            label: "Ubicación",
            icon: <FaMapMarkerAlt />,
            to: "/ubicacion"
        }
    ]
    const solicitudVisitasArray = [
        {
            label: "Solicitudes Pendientes",
            icon: <FaClock />,
            to: "/solicitudes-visita"
        },
        {
            label: "Gestión de Visitas",
            icon: <FaCalendarCheck />,
            to: "/gestion-visita"
        },
        {
            label: "Generar Reporte",
            icon: <HiOutlineDocumentReport />,
            to: "/consultar-visitas"
        }
    ]
    const visitasDirectasArray = [
        {
            label: "Gestión de Visitas",
            icon: <FaRegCalendarAlt />,
            to: "/gestion-visitas-directas"
        }
    ]
    const publicacionesArray = [
        {
            label: "Gestión de Publicaciones",
            icon: <FaBookReader />,
            to: "/publicaciones"
        },
        {
            label: "Gestión de Autores",
            icon: <FaPencilAlt />,
            to: "/autores"
        },
        {
            label: "Gestión de Tipo de Publicaciones",
            icon: <FaBookmark />,
            to: "/tipo-publicaciones"
        }
    ]

    const handleButton = () => {
        setSidebarOpen(!sidebarOpen)
    }

    const handleMenuInventario = () => {
        setMostrarMenuInventario(!mostrarMenuInventario)
        setMostrarMenuSolicitudVisitas(false)
        setMostrarMenuVisitasDirectas(false)
        setMostrarMenuPublicaciones(false)
    }

    const handleMenuSolicitudVisitas = () => {
        setMostrarMenuSolicitudVisitas(!mostrarMenuSolicitudVisitas)
        setMostrarMenuInventario(false)
        setMostrarMenuVisitasDirectas(false)
        setMostrarMenuPublicaciones(false)
    }

    const handleMenuVisitasDirectas = () => {
        setMostrarMenuVisitasDirectas(!mostrarMenuVisitasDirectas)
        setMostrarMenuSolicitudVisitas(false)
        setMostrarMenuInventario(false)
        setMostrarMenuPublicaciones(false)
    }

    const handleMenuPublicaciones = () => {
        setMostrarMenuPublicaciones(!mostrarMenuPublicaciones)
        setMostrarMenuSolicitudVisitas(false)
        setMostrarMenuInventario(false)
        setMostrarMenuVisitasDirectas(false)
    }

    return (
        <Container isOpen = {sidebarOpen}>
                <button className='sidebarButton' onClick={handleButton}>
                    <AiOutlineLeft />
                </button>

                <div className='LogoContent'>
                    <div className='imgContent'>
                        <img src={Logo} />
                    </div>
                </div>

                {
                    menuPrincipal.map(
                        ({icon, label, to}) => (
                            <div className='LinkContainer' key={label}>
                                <NavLink title={!sidebarOpen ? label : ''} to={to} className={({isActive}) => `Links${isActive ? ` active` : ``}`}>
                                    <div className='LinkIcon'>
                                        {icon}
                                    </div>
                                    {
                                        sidebarOpen && (
                                            <span>{label}</span>
                                        )
                                    }
                                </NavLink>
                            </div>
                        )
                    )
                }

                <p className='SidebarTema Principal'>COLECCIÓN</p>
                <div title={!sidebarOpen ? 'Inventario' : ''} onClick={() => handleMenuInventario()} className={mostrarMenuInventario ? "BotonDropdown Inventario active" : "BotonDropdown Inventario"}>
                    <div className='LinkIcon'>
                        <FaBook />
                    </div>
                    {
                        sidebarOpen && <p className='SidebarTema'>Inventario</p>
                    }
                    
                </div>
                
                <div className={mostrarMenuInventario ? "ContainerInventario active" : "ContainerInventario"}>
                    {
                        inventarioArray.map(
                            ({icon, label, to}) => (
                                    <div className='LinkContainer' key={label}>
                                        <NavLink title={!sidebarOpen ? label : ''} to={to} className={({isActive}) => `Links${isActive ? ` active` : ``}`}>
                                            <div className='LinkIcon'>
                                                {icon}
                                            </div>
                                            {
                                                sidebarOpen && (
                                                    <span>{label}</span>
                                                )
                                            }
                                        </NavLink>
                                    </div>
                            )
                        )
                    }
                </div>

                {idTipoUsuario === '1' &&
                <>
                <p className='SidebarTema Principal'>SOLICITUDES</p>
                <div title={!sidebarOpen ? 'Solicitud de Visitas' : ''} onClick={() => handleMenuSolicitudVisitas()} className={mostrarMenuSolicitudVisitas ? "BotonDropdown SolicitudVisitas active" : "BotonDropdown SolicitudVisitas"}>
                    <div className='LinkIcon'>
                        <FaBell />
                    </div>
                    {
                        sidebarOpen && <p className='SidebarTema'>Solicitud de Visitas</p>
                    }
                </div>
                </>
                }
                
                <div className={mostrarMenuSolicitudVisitas ? "ContainerSolicitudVisitas active" : "ContainerSolicitudVisitas"}>
                    {
                        solicitudVisitasArray.map(
                            ({icon, label, to}) => (
                                <div className='LinkContainer' key={label}>
                                    <NavLink title={!sidebarOpen ? label : ''} to={to} className={({isActive}) => `Links${isActive ? ` active` : ``}`}>
                                        <div className='LinkIcon'>
                                            {icon}
                                        </div>
                                        {
                                            sidebarOpen && (
                                                <span>{label}</span>
                                            )
                                        }
                                    </NavLink>
                                </div>
                            )
                        )
                    }
                </div>

                {idTipoUsuario === '1' &&
                <>
                <p className='SidebarTema Principal'>VISITAS</p>
                <div title={!sidebarOpen ? 'Visitas Directas' : ''} onClick={() => handleMenuVisitasDirectas()} className={mostrarMenuVisitasDirectas ? "BotonDropdown VisitasDirectas active" : "BotonDropdown VisitasDirectas"}>
                    <div className='LinkIcon'>
                        <FaCheckCircle />
                    </div>
                    {
                        sidebarOpen && <p className='SidebarTema'>Visitas Directas</p>
                    }
                    
                </div>
                </>
                }

                <div className={mostrarMenuVisitasDirectas ? "ContainerVisitasDirectas active" : "ContainerVisitasDirectas"}>
                    {
                        visitasDirectasArray.map(
                            ({icon, label, to}) => (
                                <div className='LinkContainer' key={label}>
                                    <NavLink title={!sidebarOpen ? label : ''} to={to} className={({isActive}) => `Links${isActive ? ` active` : ``}`}>
                                        <div className='LinkIcon'>
                                            {icon}
                                        </div>
                                        {
                                            sidebarOpen && (
                                                <span>{label}</span>
                                            )
                                        }
                                    </NavLink>
                                </div>
                            )
                        )
                    }
                </div>

                <p className='SidebarTema Principal'>PUBLICACIONES</p>
                <div title={!sidebarOpen ? 'Publicaciones' : ''} onClick={() => handleMenuPublicaciones()} className={mostrarMenuPublicaciones ? "BotonDropdown Publicaciones active" : "BotonDropdown Publicaciones"}>
                    <div className='LinkIcon'>
                        <FaBookOpen />
                    </div>
                    {
                        sidebarOpen && <p className='SidebarTema'>Publicaciones</p>
                    }
                    
                </div>
                
                <div className={mostrarMenuPublicaciones ? "ContainerPublicaciones active" : "ContainerPublicaciones"}>
                    {
                        publicacionesArray.map(
                            ({icon, label, to}) => (
                                <div className='LinkContainer' key={label}>
                                    <NavLink title={!sidebarOpen ? label : ''} to={to} className={({isActive}) => `Links${isActive ? ` active` : ``}`}>
                                        <div className='LinkIcon'>
                                            {icon}
                                        </div>
                                        {
                                            sidebarOpen && (
                                                <span>{label}</span>
                                            )
                                        }
                                    </NavLink>
                                </div>
                            )
                        )
                    }
                </div>

                <p className='SidebarTema Principal'>USUARIO</p>
                {idTipoUsuario === '1' &&
                <div className='LinkContainer' key='usuarios'>
                <NavLink title={!sidebarOpen ? 'Usuarios' : ''} to='/usuarios' className={({isActive}) => `Links${isActive ? ` active` : ``}`}>
                        <div title='Usuarios' className='LinkIcon'>
                            {<FaUserAlt />}
                        </div>
                        {
                            sidebarOpen && (
                                <span>Usuarios</span>
                            )
                        }
                    </NavLink>
                </div>
                }

                <div className='LinkContainer' key='salir'>
                    <Link to="/login" type='button' title={!sidebarOpen ? 'Cerrar Sesión' : ''} className='Links'>
                        <div title='Cerrar Sesión' className='LinkIcon'>
                            {<MdLogout />}
                        </div>
                        {
                            sidebarOpen && (
                                <span>Cerrar Sesión</span>
                            )
                        }
                    </Link>
                </div>
        </Container>
    );
}
 
export default Sidebar;
